import React, { useState, useRef, Suspense } from 'react';
import axios from 'axios';
import 'react-quill/dist/quill.snow.css';

// Dynamically import ReactQuill only when the component is rendered
const ReactQuill = React.lazy(() => import('react-quill'));


const BlogPostForm = () => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [author, setAuthor] = useState('');
  const [category, setCategory] = useState('');
  const [tags, setTags] = useState('');
  const [images, setImages] = useState([]); 
  const [message, setMessage] = useState('');
  
  const quillRef = useRef(null);

  const handleImageUpload = async (event) => {
    const files = event.target.files;
    if (files.length === 0) return;

    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('images', files[i]);
    }

    try {
      const response = await axios.post('https://wholeness-forward.onrender.com/api/blog/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      setImages([...images, ...response.data.imageUrls]);
    } catch (error) {
      console.error('Error uploading images:', error);
      setMessage('Error uploading images');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const newBlogPost = {
        title,
        content,
        author,
        category,
        tags: tags.split(',').map(tag => tag.trim()),
        images,
      };

      await axios.post('https://wholeness-forward.onrender.com/api/blog', newBlogPost);
      setMessage('Blog post created successfully!');

      setTitle('');
      setContent('');
      setAuthor('');
      setCategory('');
      setTags('');
      setImages([]);
    } catch (error) {
      console.error('Error creating blog post:', error);
      setMessage('Error creating blog post');
    }
  };

  return (
    <div>
      <h1>Create a Blog Post</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Title</label>
          <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} required />
        </div>

        <div>
          <label>Content</label>
          <Suspense fallback={<div>Loading editor...</div>}>
            <ReactQuill 
              ref={quillRef}
              theme="snow" 
              value={content} 
              onChange={setContent} 
              placeholder="Write your blog content here..." 
            />
          </Suspense>
        </div>

        <div>
          <label>Upload Images</label>
          <input type="file" multiple accept="image/*" onChange={handleImageUpload} />
          <div className="image-preview">
            {images.map((url, index) => (
              <img key={index} src={url} alt="Blog" className="preview-image" />
            ))}
          </div>
        </div>

        <div>
          <label>Author</label>
          <input type="text" value={author} onChange={(e) => setAuthor(e.target.value)} required />
        </div>

        <div>
          <label>Category</label>
          <input type="text" value={category} onChange={(e) => setCategory(e.target.value)} required />
        </div>

        <div>
          <label>Tags (comma separated)</label>
          <input type="text" value={tags} onChange={(e) => setTags(e.target.value)} />
        </div>

        <button type="submit">Post Blog</button>
      </form>

      {message && <p>{message}</p>}
    </div>
  );
};

export default BlogPostForm;
